import type { SVGProps } from "react";
import * as React from "react";

const SvgCloudLightning = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cloud-lightning_svg__a)">
      <path
        fill="currentColor"
        d="M18.801 15.92a1 1 0 0 0 .398 1.96zM18 7v1h.001zm-1.26 0-.968.25a1 1 0 0 0 .968.75zM4.636 16.875a1 1 0 1 0 .968-1.75zm9.196-5.32a1 1 0 1 0-1.664-1.11zM9 17l-.832-.555A1 1 0 0 0 9 18zm6 0 .832.555A1 1 0 0 0 15 16zm-4.832 5.445a1 1 0 0 0 1.664 1.11zm9.031-4.565a6 6 0 0 0 3.637-2.321l-1.61-1.187A4 4 0 0 1 18.8 15.92zm3.637-2.321a6 6 0 0 0 1.139-4.162l-1.99.201a4 4 0 0 1-.76 2.774zm1.139-4.162a6 6 0 0 0-1.948-3.85l-1.34 1.484a4 4 0 0 1 1.298 2.567zm-1.948-3.85A6 6 0 0 0 17.999 6l.002 2a4 4 0 0 1 2.685 1.031zM18 6h-1.26v2H18zm-.292.75a9 9 0 0 0-2.11-3.864L14.13 4.244a7 7 0 0 1 1.642 3.006zm-2.11-3.864A9 9 0 0 0 11.906.485l-.647 1.892a7 7 0 0 1 2.871 1.867zM11.906.485A9 9 0 0 0 7.518.123l.328 1.972a7 7 0 0 1 3.413.282zM7.518.123a9 9 0 0 0-4.035 1.762l1.225 1.582a7 7 0 0 1 3.138-1.372zM3.483 1.885A9 9 0 0 0 .767 5.351l1.829.811a7 7 0 0 1 2.112-2.695zM.767 5.351a9 9 0 0 0-.746 4.34l1.994-.154a7 7 0 0 1 .58-3.375zm-.746 4.34a9 9 0 0 0 1.401 4.174l1.683-1.081a7 7 0 0 1-1.09-3.247zm1.401 4.174a9 9 0 0 0 3.214 3.01l.968-1.75a7 7 0 0 1-2.5-2.341zm10.746-3.42-4 6 1.664 1.11 4-6zM9 18h6v-2H9zm5.168-1.555-4 6 1.664 1.11 4-6z"
      />
    </g>
    <defs>
      <clipPath id="cloud-lightning_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCloudLightning;
